"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animations = void 0;
var loaderWhite = {
  nm: 'loader',
  ddd: 0,
  h: 44,
  w: 44,
  meta: {
    g: 'LottieFiles AE 3.2.2'
  },
  layers: [{
    ty: 3,
    nm: 'Null 2',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [91.67, 91.67, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [22, 22, 0],
        ix: 2
      },
      r: {
        a: 1,
        k: [{
          o: {
            x: 0.167,
            y: 0.167
          },
          i: {
            x: 0.833,
            y: 0.833
          },
          s: [0],
          t: 0
        }, {
          s: [376],
          t: 59
        }],
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 0,
        ix: 11
      }
    },
    ef: [],
    ind: 1
  }, {
    ty: 4,
    nm: 'Shape Layer 1',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [94.796, 94.796, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [-0.187, 1.05, 0],
        ix: 2
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 100,
        ix: 11
      }
    },
    ef: [],
    shapes: [{
      ty: 'gr',
      bm: 0,
      hd: false,
      mn: 'ADBE Vector Group',
      nm: 'Ellipse 1',
      ix: 1,
      cix: 2,
      np: 4,
      it: [{
        ty: 'el',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Shape - Ellipse',
        nm: 'Ellipse Path 1',
        d: 1,
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        s: {
          a: 0,
          k: [45.435, 45.435],
          ix: 2
        }
      }, {
        ty: 'tm',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Filter - Trim',
        nm: 'Trim Paths 1',
        ix: 2,
        e: {
          a: 1,
          k: [{
            o: {
              x: 0.75,
              y: 0
            },
            i: {
              x: 0.833,
              y: 0.833
            },
            s: [5],
            t: 0
          }, {
            s: [100],
            t: 30
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        s: {
          a: 1,
          k: [{
            o: {
              x: 0.167,
              y: 0.167
            },
            i: {
              x: 0.25,
              y: 1
            },
            s: [0],
            t: 30
          }, {
            s: [95],
            t: 59
          }],
          ix: 1
        },
        m: 1
      }, {
        ty: 'st',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Graphic - Stroke',
        nm: 'Stroke 1',
        lc: 2,
        lj: 1,
        ml: 1,
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        c: {
          a: 0,
          k: [1, 1, 1],
          ix: 3
        }
      }, {
        ty: 'tr',
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [94.399, 94.399],
          ix: 3
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        p: {
          a: 0,
          k: [0.187, -1.05],
          ix: 2
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        }
      }]
    }],
    ind: 2,
    parent: 1
  }],
  v: '4.8.0',
  fr: 30,
  op: 59,
  ip: 0,
  assets: []
};
var loaderSky = {
  nm: 'loader',
  ddd: 0,
  h: 44,
  w: 44,
  meta: {
    g: 'LottieFiles AE 3.2.2'
  },
  layers: [{
    ty: 3,
    nm: 'Null 2',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [91.67, 91.67, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [22, 22, 0],
        ix: 2
      },
      r: {
        a: 1,
        k: [{
          o: {
            x: 0.167,
            y: 0.167
          },
          i: {
            x: 0.833,
            y: 0.833
          },
          s: [0],
          t: 0
        }, {
          s: [376],
          t: 59
        }],
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 0,
        ix: 11
      }
    },
    ef: [],
    ind: 1
  }, {
    ty: 4,
    nm: 'Shape Layer 1',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [94.796, 94.796, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [-0.187, 1.05, 0],
        ix: 2
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 100,
        ix: 11
      }
    },
    ef: [],
    shapes: [{
      ty: 'gr',
      bm: 0,
      hd: false,
      mn: 'ADBE Vector Group',
      nm: 'Ellipse 1',
      ix: 1,
      cix: 2,
      np: 4,
      it: [{
        ty: 'el',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Shape - Ellipse',
        nm: 'Ellipse Path 1',
        d: 1,
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        s: {
          a: 0,
          k: [45.435, 45.435],
          ix: 2
        }
      }, {
        ty: 'tm',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Filter - Trim',
        nm: 'Trim Paths 1',
        ix: 2,
        e: {
          a: 1,
          k: [{
            o: {
              x: 0.75,
              y: 0
            },
            i: {
              x: 0.833,
              y: 0.833
            },
            s: [5],
            t: 0
          }, {
            s: [100],
            t: 30
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        s: {
          a: 1,
          k: [{
            o: {
              x: 0.167,
              y: 0.167
            },
            i: {
              x: 0.25,
              y: 1
            },
            s: [0],
            t: 30
          }, {
            s: [95],
            t: 59
          }],
          ix: 1
        },
        m: 1
      }, {
        ty: 'st',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Graphic - Stroke',
        nm: 'Stroke 1',
        lc: 2,
        lj: 1,
        ml: 1,
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        c: {
          a: 0,
          k: [0, 0.0157, 0.8588],
          ix: 3
        }
      }, {
        ty: 'tr',
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [94.399, 94.399],
          ix: 3
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        p: {
          a: 0,
          k: [0.187, -1.05],
          ix: 2
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        }
      }]
    }],
    ind: 2,
    parent: 1
  }],
  v: '4.8.0',
  fr: 30,
  op: 59,
  ip: 0,
  assets: []
};
var loaderSage = {
  nm: 'loader',
  ddd: 0,
  h: 44,
  w: 44,
  meta: {
    g: 'LottieFiles AE 3.2.2'
  },
  layers: [{
    ty: 3,
    nm: 'Null 2',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [91.67, 91.67, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [22, 22, 0],
        ix: 2
      },
      r: {
        a: 1,
        k: [{
          o: {
            x: 0.167,
            y: 0.167
          },
          i: {
            x: 0.833,
            y: 0.833
          },
          s: [0],
          t: 0
        }, {
          s: [376],
          t: 59
        }],
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 0,
        ix: 11
      }
    },
    ef: [],
    ind: 1
  }, {
    ty: 4,
    nm: 'Shape Layer 1',
    sr: 1,
    st: 0,
    op: 60,
    ip: 0,
    hd: false,
    ddd: 0,
    bm: 0,
    hasMask: false,
    ao: 0,
    ks: {
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [94.796, 94.796, 100],
        ix: 6
      },
      sk: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [-0.187, 1.05, 0],
        ix: 2
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      sa: {
        a: 0,
        k: 0
      },
      o: {
        a: 0,
        k: 100,
        ix: 11
      }
    },
    ef: [],
    shapes: [{
      ty: 'gr',
      bm: 0,
      hd: false,
      mn: 'ADBE Vector Group',
      nm: 'Ellipse 1',
      ix: 1,
      cix: 2,
      np: 4,
      it: [{
        ty: 'el',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Shape - Ellipse',
        nm: 'Ellipse Path 1',
        d: 1,
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        s: {
          a: 0,
          k: [45.435, 45.435],
          ix: 2
        }
      }, {
        ty: 'tm',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Filter - Trim',
        nm: 'Trim Paths 1',
        ix: 2,
        e: {
          a: 1,
          k: [{
            o: {
              x: 0.75,
              y: 0
            },
            i: {
              x: 0.833,
              y: 0.833
            },
            s: [5],
            t: 0
          }, {
            s: [100],
            t: 30
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        s: {
          a: 1,
          k: [{
            o: {
              x: 0.167,
              y: 0.167
            },
            i: {
              x: 0.25,
              y: 1
            },
            s: [0],
            t: 30
          }, {
            s: [95],
            t: 59
          }],
          ix: 1
        },
        m: 1
      }, {
        ty: 'st',
        bm: 0,
        hd: false,
        mn: 'ADBE Vector Graphic - Stroke',
        nm: 'Stroke 1',
        lc: 2,
        lj: 1,
        ml: 1,
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        c: {
          a: 0,
          k: [0, 0.302, 0.1647],
          ix: 3
        }
      }, {
        ty: 'tr',
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [94.399, 94.399],
          ix: 3
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        p: {
          a: 0,
          k: [0.187, -1.05],
          ix: 2
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        }
      }]
    }],
    ind: 2,
    parent: 1
  }],
  v: '4.8.0',
  fr: 30,
  op: 59,
  ip: 0,
  assets: []
};
var animations = exports.animations = {
  loader: {
    sky: loaderSky,
    sage: loaderSage
  },
  loaderWhite: {
    sky: loaderWhite,
    sage: loaderWhite
  }
};